/* @flow */
import cx from 'classnames';
import * as React from 'react';

import './styles/Columns.scss';

/**
 * ## DEPRECATED – Use [Columns2](/internal/components/Columns2) instead.
 * ### Two-column grid.
 *
 *
 * ```example
 * <Columns>
 *   <div>
 *     Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt
 *     ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation
 *     ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in
 *     reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.
 *   </div>
 *   <div>
 *     Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt
 *     ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation
 *     ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in
 *     reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.
 *   </div>
 * </Columns>
 * ```
 *
 * ```example
 * <Columns divided>
 *   <div>
 *     Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt
 *     ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation
 *     ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in
 *     reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.
 *   </div>
 *   <div>
 *     Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt
 *     ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation
 *     ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in
 *     reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.
 *   </div>
 * </Columns>
 * ```
 */

type Props = {
  /** `border` between children */
  divided?: boolean,
  className?: string,
  children?: React$Element<any> | React$Element<any>[],
};

class Columns extends React.Component<Props> {
  render() {
    const { children, className, divided } = this.props;
    const body = React.Children.map(children, (child, index) => {
      return React.cloneElement(child, {
        key: index,
        className: cx('Columns-column', child.props.className, {
          'Columns-column--divided': divided,
        }),
      });
    });
    return <div className={cx('Columns', className)}>{body}</div>;
  }
}
export default Columns;
